import { useQueries, UseQueryOptions } from 'react-query';
import { IssuerDto } from '../../services/dtos/issuer/issuer.dto';
import { fetchIssuer } from '../../services/issuers/issuers.service';
import { hasValue } from '../../utils/typeGuards';
import { queryKeys } from '../queryKeyFactory';

interface QueriesResult {
  isLoading: boolean;
  isError: boolean;
  data: IssuerDto[] | undefined;
}

export default (ids: string[], options?: UseQueryOptions<IssuerDto>): QueriesResult => {
  const results = useQueries(
    ids.map((id) => {
      return {
        queryKey: queryKeys.fetchIssuers.single(id),
        queryFn: () => fetchIssuer(id),
        ...options,
      };
    })
  );

  const isLoading = results.some((r) => r.isLoading);
  const isError = results.every((r) => r.isError);
  return {
    isLoading,
    isError,
    data: results?.map((r) => r.data).filter(hasValue),
  };
};
